var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthenticationMethod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2019_2235)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2019_2235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2501 12.5L33.7501 15M33.7501 15L37.5001 18.75L33.1251 23.125L29.3751 19.375M33.7501 15L29.3751 19.375M24.2376 24.5125C24.883 25.1493 25.3961 25.9075 25.7473 26.7435C26.0985 27.5794 26.2808 28.4766 26.2839 29.3833C26.2869 30.29 26.1106 31.1884 25.765 32.0266C25.4194 32.8649 24.9114 33.6265 24.2703 34.2677C23.6291 34.9088 22.8675 35.4168 22.0292 35.7624C21.191 36.108 20.2926 36.2843 19.3859 36.2813C18.4792 36.2782 17.582 36.0959 16.7461 35.7447C15.9101 35.3935 15.1519 34.8804 14.5151 34.235C13.2628 32.9384 12.5698 31.2017 12.5855 29.3991C12.6011 27.5965 13.3242 25.8722 14.5988 24.5975C15.8735 23.3228 17.5979 22.5998 19.4005 22.5841C21.2031 22.5685 22.9397 23.2614 24.2363 24.5138L24.2376 24.5125ZM24.2376 24.5125L29.3751 19.375",
    stroke: "#5177FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2019_2235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2019_2235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationMethod);
export default __webpack_public_path__ + "static/media/authentication_method.fd251c946fc23e5008ad4f18ad330b7e.svg";
export { ForwardRef as ReactComponent };